export const SCORE_FACTOR_DESCRIPTIONS = {
  "95": "No negative reason code",
  "93": "Not enough balance paid down over time on first mortgage accounts",
  "92": "Deliquent ot derogatory first mortgage",
  "91": "Balances on deliquent or derogatory revolving accounts are too high",
  "90": "No open revolving accounts in your credit file",
  "89": "No negative reason code",
  "79": "No negative reason code",
  "59": "Balances on retail cards are to high compared with credit limits",
  "49": "Not enough balance paid down over time on revolving accounts",
  "46": "Oldest revolving account was opened too recently",
  "44": "Balances on revolving accts are too high compared with credit limits",
  "43": "Too many revolving accounts with high balance compared to credit limit",
  "19": "No negative reason code",
  "97": "Too few open accounts",
  "88": "Bankrupty",
  "87": "Unpaid collections",
  "86": "Derogatory public records",
  "85": "Too many inquiries",
  "83": "No negative reason code",
  "84": "Number of inquiries was a factor in determining the source",
  "82": "Lack of recently reported student loans",
  "81": "Not enough balance paid down over time on student loans",
  "80": "Deliquent or derogatory student loan",
  "78": "Lack of auto account information",
  "77": "No open auto accounts in your credit file",
  "76": "Deliquent or derogatory status on auto accounts in too recent",
  "75": "Payments on auto accounts less than scheduled amount",
  "74": "Balances on auto accounts are too high compared to loan amounts",
  "73": "Deliquent or Derogatory auto account",
  "72": "Too few auto accounts",
  "71": "Not enough balance paid down over time on auto accounts",
  "70": "Too high proportion of balances from loans not secured by real estate",
  "69": "Too high proportion of balances from loans not secured by real state",
  "68": "Lack of real estate secured loan information",
  "67": "No open real estate estate secured loans in your credit file",
  "66": "Deliquent or derogatory status on real estate loans is too recent",
  "65": "Oldest real estate secured loan was open too recently",
  "64": "Not enough balance paid down over time on real estate secured loans",
  "63": "Deliquent or derogatory real estate secured loan",
  "62": "Lack of first mortgage account information",
  "61": "No open first mortgage accounts in your credit file",
  "60": "Total deliquent or derogatory balances on real estate loans too high",
  "58": "Lack of installment account information",
  "57": "No open installment accounts in your credit file",
  "56": "Lack of recently reported installment accounts",
  "55": "Lack of recently reported auto accounts",
  "54": "Deliquent or derogatory status on installment accounts is too recent",
  "53": "Not enough balance paid down over time on installment accounts",
  "52": "Deliquent or derogatory installment account",
  "51": "Too few installment accounts recently paid as agreed",
  "50": "Balances on personal installment accts too high compared to loan amts",
  "48": "Lack of retail account information",
  "47": "No open retail accounts in your credit file",
  "45": "Not enough balance paid down overtime on retail accounts",
  "42": "Total credit limits on open revolving accounts are too low",
  "41": "Average time since revolving accounts opened is too recent",
  "40": "Too many deliquent or derogatory revolving accounts",
  "39": "Balances on delinquent or derogatory bankcards are too high",
  "38": "Lack of bankcard account information",
  "37": "No open bankcards on your credit file",
  "36": "Lack of recently reported revolving accounts",
  "35": "Lack of revolving account information",
  "34": "Most recently opened revolving account is too new",
  "33": "Not enough balance paid down over time on bankcards",
  "32": "Oldest bankcard was opened too recently",
  "31": "Not enough available credit on revolving accounts",
  "30": "Too few open revolving accounts",
  "29": "Balances on bankcards are too high compared with credit limits",
  "28": "Average credit limit on open bankcards is too low",
  "27": "Delinquent or derogatory status on revolving accounts is too recent",
  "26": "Balances on bankcards are too high",
  "25": "Too high proportion of balances from bankcards",
  "24": "Too many bankcards with high balance compared to credit limit",
  "23": "Too high proportion of bankcards recently opened",
  "22": "Too few bankcards with high credit limit",
  "21": "too many bankcards with high balance",
  "20": "Delinquent or derogatory bankcard",
  "18": "Lack of account information",
  "17": "No open accounts in your credit file",
  "16": "Total of credit limits and loan amounts is too low",
  "15": "Lack of recently reported accounts",
  "14": "Too high proportion of accounts recently opened",
  "13": "Balances on delinquent or derogatory accounts are too high",
  "12": "Delinquent or derogatory status on accounts is too recent",
  "11": "Oldest account was opened too recently",
  "10": "Too few accounts paid as agreed",
  "9": "Delinquent or derogatory account",
  "8": "Too few accounts recently paid as agreed",
  "7": "Too many delinquent or derogatory accounts",
  "6": "Too many accounts recently opened",
  "5": "Too many recent delinquencies",
  "4": "Balanced on accts too high compared to credit limits and load amounts",
};
